import routes from '@/modules/invoices/invoices-routes';
import store from '@/modules/invoices/invoices-store';

export default {
  routes,
  store,
};
